import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from './utils';

const BASE_PATHNAME = 'menus';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const getByIds = makeGetByIds({ dataSource, url: BASE_PATHNAME });
  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const create = ({ values: json }) => dataSource.post(BASE_PATHNAME, { json }).json();
  const update = ({ values }) => dataSource.put(`${BASE_PATHNAME}`, { json: values }).json();
  const upsert = (json) => (json.values.id ? update(json) : create(json));
  
  // Add new method for updating only navigation menus
  const updateNavigationMenus = ({ eventId, navigationMenus }) => 
    dataSource.put(`config-cis/${eventId}/navigation-menus`, { json: navigationMenus }).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['type']),
    }),

    getById,
    getByIds,
    getEmptyList: getDefaultEmptyList,
    create,
    update,
    upsert,
    updateNavigationMenus,
  };
};
